import React from 'react'
import { Household } from '@wedding-site/common/types/households'

export const Context = React.createContext({} as Household)